import { Link, useParams } from 'react-router-dom';
import Navbar from '../navigation/Navbar';
import Tips from '../JobHome/Tips';
import Blogs from '../app/Blogs';
import Footer from '../../components/app/Footer';
import Ad from "../../images/talent/ad.png";
import JobDesc from '../DailyJobs/JobDesc';
import { Typography } from '@mui/material';
import toList from '../utils/ComponentUtil';
import { useState, useEffect } from 'react';
import InternshipTemplate from './InternshipTemplate';
import InternshipsAPI from '../Apis/InternshipsAPI';
import InternshipCard from './InternshipCard';
import HireTalent from '../app/HireTalent';
import "./InternshipTemplate.scss";


function InternshipDetailsPage() {
    const { id } = useParams();
    const [internshipDetails, setInternshipDetails] = useState({});
    const [similarInternships, setSimilarInternships] = useState([])

    useEffect(() => {
        const { internship, similarInternships } = InternshipsAPI.getInternshipDetails(id);
        setInternshipDetails(internship);
        setSimilarInternships(similarInternships);
    }, [id]);



    const breadcrumbs = [toList([{ to: "/", child: "Home" },{ to: "/internships", child: "Internship" }, { to: "/internships", child: (internshipDetails?.name || ' ') }], Link)
        , <Typography className="job-page-name">{internshipDetails?.title}</Typography>]

    return (
        <div className='internship-details-page'>
            <Navbar selected='Work From Home' />
            <JobDesc name='Google Advertisment' jobImg={Ad} talents={similarInternships}
                breadcrumbs={breadcrumbs} startPosting={false}
                talentsTitle='Other Internship Works'
                template={InternshipCard}
                render={() => {
                    return <InternshipTemplate internship={internshipDetails} />
                }}></JobDesc>
            <HireTalent title={'Recent ' + internshipDetails?.name + ' Posts'} subTitle=''
                card={InternshipCard} viewMoreCount={3} perRow={3} talents={InternshipsAPI.fetchInternships()?.data} />
            <Tips />
            <Blogs></Blogs>
            <Footer></Footer>
        </div>
    );
}

export default InternshipDetailsPage;